import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_PROPERTY_VERIFIED_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import { DSIcon } from '../../../base';

import { HomeCheckerShape } from '../../shapes/HomeChecker';

import VerificationInfo from './VerificationInfo';

import styles from './PropertyVerifiedModal.module.scss';

const PropertyVerifiedModal = ({
  homechecker = null,
  verificationDate = null
}) => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_PROPERTY_VERIFIED_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="normal"
      className={styles['property-verified-modal']}
    >
      <ModalHeader
        className={styles['property-verified-modal__header']}
        onRequestClose={handleModalClose}
        label={
          <>
            <DSIcon name="check_circle_transparent" size="ml" />
            <br />
            {trans('property_verified.modal.title')}
          </>
        }
      />
      <ModalBody className={styles['property-verified-modal__body']}>
        <p>{trans('property_verified.modal.description')}</p>

        <VerificationInfo
          homechecker={homechecker}
          verificationDate={verificationDate}
        />

        <div>
          <h5 className={styles['property-verified-modal__conditions-title']}>
            {trans('property_verified.modal.conditions1')}
          </h5>
          <ul className={styles['property-verified-modal__conditions-list']}>
            <li>{trans('property_verified.modal.conditions1.item1')}</li>
            <li>{trans('property_verified.modal.conditions1.item2')}</li>
          </ul>
        </div>

        <div>
          <h5 className={styles['property-verified-modal__conditions-title']}>
            {trans('property_verified.modal.conditions2')}
          </h5>
          <p>{trans('property_verified.modal.conditions2.item1')}</p>
        </div>
      </ModalBody>
    </Modal>
  ) : null;
};

PropertyVerifiedModal.propTypes = {
  homechecker: PropTypes.shape(HomeCheckerShape),
  verificationDate: PropTypes.string
};

export default PropertyVerifiedModal;
